import React from 'react';

const DropdownField = ({
  label,
  hint,
  required = false,
  value,
  onChange,
  name,
  options = [],
  error,
  placeholder = 'Select',
  inputProps = {},
  disabled = false,
}) => {
  // Compatible with Semantic UI-like syntax
  const handleChange = (e) => {
    const selectedValue = e.target.value;
    if (onChange) {
      onChange(e, { name, value: selectedValue }); // mimic Semantic UI behavior
    }
  };

  const isDisabled = disabled || inputProps.readOnly;

  return (
    <div className="form-group" style={{ marginBottom: 10, display: 'block', alignItems: 'initial', }}>
      {label && (
        <label
          className="pd10botbuilder"
          style={{
            display: 'block',
            marginBottom: 5,
            fontWeight: 500,
            color: '#495057',
          }}
        >
          {label}
          {required && <span style={{ color: 'red' }}>*</span>}
        </label>
      )}

      <select
        name={name}
        className={`form-control ${error ? 'is-invalid' : ''}`}
        value={value || ''}
        onChange={handleChange}
        style={{
          border: error ? '1px solid #dc3545' : '1px solid #e1e5e9',
          borderRadius: '5px',
          padding: '10px 15px',
          fontSize: '13px',
          backgroundColor: isDisabled ? '#f8f9fa' : 'white',
          cursor: isDisabled ? 'not-allowed' : 'pointer',
        }}
        disabled={isDisabled}
        {...inputProps}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.text}
          </option>
        ))}
      </select>
      {/* Info Icon Tooltip */}
      {hint && (
        <div
          style={{
            display: 'flex',
            marginTop: '5px',
          }}
        >
          <i className="info circle icon" style={{ color: '#2196f3' }}></i>
          <span style={{
            fontSize: '12px',
            fontWeight: 400,
            color: '#555',
          }}>{hint}</span>
        </div>
      )}

      {error && (
        <div
          className="invalid-feedback d-block"
          style={{
            color: '#dc3545',
            fontSize: '12px',
            marginTop: '5px',
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default DropdownField;
